import React, { useState, useRef, useEffect } from "react";
import {
  PlusSquareOutlined,
  MinusSquareOutlined,
  PlusCircleOutlined,
  MinusCircleOutlined,
  DownloadOutlined,
  ImportOutlined,
} from "@ant-design/icons";
import {
  Cascader,
  Select,
  Form,
  Input,
  Button,
  Row,
  Col,
  message,
  Modal,
  Upload,
} from "antd";
import sysApi from "@api/sys";
import AddModal from "@components/Modal";
import stationApi from "@api/station";
import InspectionApi from "@api/inspectionnew";
import PeriodsComponent from "@components/PeriodsComponent";
import PatrolItem from "@components/PatrolItem";
import { WindowScroller } from "react-virtualized";
import AutoSizer from "react-virtualized-auto-sizer";
import { VariableSizeList } from "react-window";
import ResizeObserver from "rc-resize-observer";
import { isHaveVal } from "../../../utils/common";
import download from "../../../utils/download";

const { BASEURL, swPatrol } = window.globalConfig;

const { SHOW_CHILD } = Cascader;

import "./add.scss";

const formLayout = {
  labelCol: { span: 2 },
  wrapperCol: { span: 22 },
};

const formLayout1 = {
  labelCol: { span: 5 },
  wrapperCol: { span: 19 },
};

const AddModel = ({
  title,
  visible,
  formData,
  cancel,
  stationData = [],
  tmpLs = [],
  patrolDepts = [],
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState();
  const [deviceLs, setDeviceLs] = useState([]);
  const [tempentItems, setTempentItems] = useState([]);
  const [defectslevelLs, setDefectslevelLs] = useState([]);
  const rowHeights = useRef({});
  const listRef = useRef(null);
  const [expandParams, setExpandParams] = useState({});
  const [batchDeviceVisible, setBatchDeviceVisible] = useState(false);
  const [batchDeviceList, setBatchDeviceList] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const fieldNames = {
    label: "itemName",
    value: "id",
    children: "child",
  };
  const [downLoading, setDownLoading] = useState(false);
  const [importLoading, setImportLoading] = useState(false);
  const [patrolTemplateType, setPatrolTemplateType] = useState();

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({
        ...formData,
        stationId: formData.stationId ? formData.stationId * 1 : null,
      });
      getDefectLevelLs();
      handleData();
    }
  }, [visible]);

  useEffect(() => {
    if (isHaveVal(patrolTemplateType)) {
      getTmpType(patrolTemplateType);
    }
  }, [patrolTemplateType]);

  const downFile = () => {
    const { stationId, patrolStandardTemplates } = form.getFieldsValue({});
    if (!isHaveVal(stationId)) return message.error("请选择厂站");
    const patrolDeviceRelevancyTemplateRelates = patrolStandardTemplates.map(
      (item) => ({
        deviceRelevancyId: item.deviceRelevancyIds.at(-1),
        patrolTemplateId: item.patrolTemplateId,
      }),
    );
    const params = {
      stationId,
      templateType: patrolTemplateType,
      patrolDeviceRelevancyTemplateRelates,
    };
    setDownLoading(true);
    InspectionApi.exportPatrolStandardItemTemplate(params).then((res) => {
      setDownLoading(false);
      download(res, "巡检标准.xlsx");
    });
  };

  const handleData = () => {
    const { stationId } = formData;
    if (stationId) {
      getDevice(stationId);
      setPatrolTemplateType(formData.patrolTemplateType);
    } else {
      setPatrolTemplateType(tmpLs[0].value * 1);
    }
  };

  const getDefectLevelLs = () => {
    InspectionApi.defectLevelLs({ pageNum: 1, pageSize: 999 }).then((res) => {
      setLoading(false);
      if (res.status !== "0") return;
      const arr = res.data ? res.data : [];
      setDefectslevelLs(arr);
    });
  };

  // 模板类型
  const setRowHeight = (index, size) => {
    if (rowHeights.current[index] !== size) {
      rowHeights.current = { ...rowHeights.current, [index]: size };
      listRef.current?.resetAfterIndex(index);
    }
  };

  // 巡检模板
  const getTmpType = (value) => {
    InspectionApi.insTemplateList({ status: 1 }).then((res) => {
      if (res.status == 0 && res.data) {
        const filterAry = res.data.filter((item) => item.templateType == value);
        setTempentItems(filterAry);
      }
    });
  };

  // 查询设备
  const getDevice = (stationId) => {
    stationApi.getDeviceByStationId({ stationId }).then((res) => {
      if (res.status !== "0") return;
      setDeviceLs(res.data ? res.data : []);
    });
  };

  const changeDev = (value, options, index) => {
    const tmpName = options.map((item) => item.itemName).join("-");
    const find = tempentItems.find((item) => item.templateName == tmpName);
    if (find) {
      form.setFieldValue(
        ["patrolStandardTemplates", index, "patrolTemplateId"],
        find.id,
      );
      getTmpContent(find.id, index);
    }
  };

  const showBatchDevModal = () => {
    setBatchDeviceVisible(true);
  };

  const changeBatchDev = (value, selectedOptions) => {
    setBatchDeviceList(value);
    setSelectedOptions(selectedOptions);
  };

  const closeBatchDevModal = () => {
    setBatchDeviceVisible(false);
    setBatchDeviceList([]);
    setSelectedOptions([]);
  };

  const addBatchDev = () => {
    if (batchDeviceList.length == 0) return message.error("请选择设备");
    const currentValue = form.getFieldValue("patrolStandardTemplates");
    let newArr = [...currentValue];
    const tmpIds = [];
    if (
      currentValue.length == 1 &&
      currentValue[0].deviceRelevancyIds.length == 0
    ) {
      newArr = [];
    }
    batchDeviceList.forEach((item, index) => {
      const arr = selectedOptions[index];
      const tmpName = arr.map((subItem) => subItem.itemName).join("-");
      const find = tempentItems.find(
        (subItem) => subItem.templateName == tmpName,
      );
      if (find) {
        tmpIds.push(find.id);
      }
      newArr.push({
        deviceRelevancyIds: item,
        patrolStandardItems: [
          {
            defectLevelId: null,
            itemContent: "",
            lowerLimit: "",
            numericFlag: 0,
            runStatus: [],
            safetyPerilFlag: 0,
            unit: "",
            upperLimit: "",
            period: null,
            periods: [
              {
                beginTime: "",
                date: "",
                day: null,
                month: null,
                period: null,
                weekDay: null,
              },
            ],
          },
        ],
        patrolTemplateId: find ? find.id : null,
      });
    });
    if (tmpIds.length > 0) {
      InspectionApi.getTemplateItemsByIds({ ids: tmpIds }).then((res) => {
        if (res.status !== "0") return;
        newArr.forEach((item) => {
          const patrolTemplateId = item.patrolTemplateId;
          if (patrolTemplateId) {
            res.data[patrolTemplateId] &&
              res.data[patrolTemplateId].forEach((subItem) => {
                subItem.period = null;
                subItem.periods = [
                  {
                    beginTime: "",
                    date: "",
                    day: null,
                    month: null,
                    period: null,
                    weekDay: null,
                  },
                ];
              });
            item.patrolStandardItems = res.data[patrolTemplateId];
          }
        });
        form.setFieldValue("patrolStandardTemplates", newArr);
      });
    } else {
      form.setFieldValue("patrolStandardTemplates", newArr);
    }
    closeBatchDevModal();
  };

  const getRowHeight = (index) => {
    return rowHeights.current[index] || 200;
  };

  const changCycle = (period, i1, i2) => {
    const currentValue = form.getFieldValue([
      "patrolStandardTemplates",
      i1,
      "patrolStandardItems",
      i2,
      "periods",
    ]);
    const newArr = [...currentValue];
    newArr.map((item) => {
      item.period = period;
    });
    form.setFieldValue([
      {
        name: [
          "patrolStandardTemplates",
          i1,
          "patrolStandardItems",
          i2,
          "period",
        ],
        value: period,
      },
      {
        name: [
          "patrolStandardTemplates",
          i1,
          "patrolStandardItems",
          i2,
          "periods",
        ],
        value: newArr,
      },
    ]);
  };

  const expandDev = (index) => {
    expandParams[index] = !expandParams[index];
    setExpandParams({ ...expandParams });
  };

  // 添加周期
  const addPeriods = (i1, i2, period) => {
    const currentPeriods = form.getFieldValue([
      "patrolStandardTemplates",
      i1,
      "patrolStandardItems",
      i2,
      "periods",
    ]);
    const newArr = [
      ...currentPeriods,
      {
        beginTime: "",
        date: "",
        day: null,
        month: null,
        period,
        weekDay: null,
      },
    ];
    form.setFieldValue(
      ["patrolStandardTemplates", i1, "patrolStandardItems", i2, "periods"],
      newArr,
    );
  };

  // 移除周期
  const removePeriods = (i1, i2, i3) => {
    const currentPeriods = form.getFieldValue([
      "patrolStandardTemplates",
      i1,
      "patrolStandardItems",
      i2,
      "periods",
    ]);
    const newArr = [...currentPeriods];
    newArr.splice(i3, 1);
    form.setFieldValue(
      ["patrolStandardTemplates", i1, "patrolStandardItems", i2, "periods"],
      newArr,
    );
  };

  // 添加巡检项
  const addInspectionItem = (i) => {
    const currentValue = form.getFieldValue([
      "patrolStandardTemplates",
      i,
      "patrolStandardItems",
    ]);
    const newArr = [
      ...currentValue,
      {
        defectLevelId: null,
        itemContent: "",
        lowerLimit: "",
        numericFlag: 0,
        runStatus: [],
        safetyPerilFlag: 0,
        unit: "",
        upperLimit: "",
        period: null,
        periods: [
          {
            beginTime: "",
            date: "",
            day: null,
            month: null,
            period: null,
            weekDay: null,
          },
        ],
      },
    ];
    form.setFieldValue(
      ["patrolStandardTemplates", i, "patrolStandardItems"],
      newArr,
    );
  };

  // 移除巡检项
  const removeInspectionItem = (i1, i2) => {
    const currentValue = form.getFieldValue([
      "patrolStandardTemplates",
      i1,
      "patrolStandardItems",
    ]);
    const newArr = [...currentValue];
    newArr.splice(i2, 1);
    form.setFieldValue(
      ["patrolStandardTemplates", i1, "patrolStandardItems"],
      newArr,
    );
  };

  // 添加巡检设备
  const addInspectionDevice = () => {
    const currentValue = form.getFieldValue("patrolStandardTemplates");
    const newArr = [
      ...currentValue,
      {
        deviceRelevancyIds: [],
        patrolStandardItems: [
          {
            defectLevelId: null,
            itemContent: "",
            lowerLimit: "",
            numericFlag: 0,
            runStatus: [],
            safetyPerilFlag: 0,
            unit: "",
            upperLimit: "",
            period: null,
            periods: [
              {
                beginTime: "",
                date: "",
                day: null,
                month: null,
                period: null,
                weekDay: null,
              },
            ],
          },
        ],
        patrolTemplateId: null,
      },
    ];
    form.setFieldValue("patrolStandardTemplates", newArr);
  };
  // 移除巡检设备
  const removeInspectionDevice = (index) => {
    const currentValue = form.getFieldValue("patrolStandardTemplates");
    const newArr = [...currentValue];
    newArr.splice(index, 1);
    form.setFieldValue("patrolStandardTemplates", newArr);
    expandParams[index] && delete expandParams[index];
    setExpandParams({ ...expandParams });
  };

  // 提交标准
  const submit = () => {
    form.validateFields().then(async (values) => {
      if (!values) return;
      setLoading(true);
      values.patrolStandardTemplates.map((item) => {
        item.deviceRelevancyId = item.deviceRelevancyIds.at(-1);
      });
      let errorMsg = "";
      outerLoop: for (
        let i = 0;
        i < values.patrolStandardTemplates.length;
        i++
      ) {
        const item = values.patrolStandardTemplates[i];
        const patrolStandardItems = item.patrolStandardItems;
        if (patrolStandardItems && patrolStandardItems.length > 0) {
          for (let j = 0; j < patrolStandardItems.length; j++) {
            const subItem = patrolStandardItems[j];
            const subItemPeriod = subItem.period;
            if (!isHaveVal(subItem.defectLevelId)) {
              errorMsg = "请选择缺陷等级";
              break outerLoop;
            }
            if (!isHaveVal(subItem.itemContent)) {
              errorMsg = "请填写巡检内容";
              break outerLoop;
            }
            if (!isHaveVal(subItem.numericFlag)) {
              errorMsg = "请选择是否填写数值";
              break outerLoop;
            }
            if (!isHaveVal(subItem.safetyPerilFlag)) {
              errorMsg = "请选择是否安全隐患";
              break outerLoop;
            }
            if (!isHaveVal(subItemPeriod)) {
              errorMsg = "请选择周期";
              break outerLoop;
            }
            const periods = subItem.periods;
            if (periods && periods.length > 0) {
              for (let k = 0; k < periods.length; k++) {
                const period = periods[k];
                if (subItemPeriod == 0) {
                  const beginTime = isHaveVal(period.beginTime);
                  if (!beginTime) {
                    errorMsg = "请选择时间";
                    break outerLoop;
                  }
                } else if (subItemPeriod == 1) {
                  const weekDay = isHaveVal(period.weekDay);
                  if (!weekDay) {
                    errorMsg = "请选择巡检日";
                    break outerLoop;
                  }
                } else if (subItemPeriod == 2) {
                  const day = isHaveVal(period.day);
                  if (!day) {
                    errorMsg = "请选择第几天!";
                    break outerLoop;
                  }
                } else if (subItemPeriod == 3) {
                  const month = isHaveVal(period.month);
                  if (!month) {
                    errorMsg = "请选择第几月!";
                    break outerLoop;
                  }
                  const day = isHaveVal(period.day);
                  if (!day) {
                    errorMsg = "请选择第几天!";
                    break outerLoop;
                  }
                }
              }
            } else {
              errorMsg = "请添加周期";
              break outerLoop;
            }
          }
        } else {
          errorMsg = "请添加巡检项";
          break outerLoop;
        }
      }
      if (errorMsg) {
        message.error(errorMsg);
        setLoading(false);
        return;
      }
      const params = { ...values, patrolTemplateType };
      if (formData && formData.id) {
        params.id = formData.id;
        // 获取流程id
        const result = await sysApi.getFlowableId({
          dictType: "sw-flowable",
          dictKey: "patrol_template_updateInfo",
        });
        if (result.status !== "0") return;
        const processId = result.data;
        InspectionApi.standUpdate(params, processId)
          .then((res) => {
            if (res.status == 0) {
              message.success("编辑成功");
              handelCancel(true);
            }
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      } else {
        InspectionApi.standAdd(params)
          .then(async (res) => {
            if (res.status == 0) {
              // const result = await sysApi.getFlowableId({
              //   dictType: "sw-flowable",
              //   dictKey: "patrol_standard_add",
              // });
              // if (result.status !== "0") return;
              // const processId = result.data;
              // const values = await InspectionApi.standardStartProcess({
              //   id: res.data,
              //   processId,
              // });
              // if (values.status !== "0") return;
              message.success("新建成功");
              handelCancel(true);
            }
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      }
    });
  };
  // 取消
  const handelCancel = (bool = false) => {
    form.resetFields();
    cancel(bool);
    setExpandParams({});
  };

  const uploadProps = {
    name: "file",
    action: `/${BASEURL}/${swPatrol}/api/standard/importPatrolStandardItemTemplate`,
    headers: {
      authorization: sessionStorage.getItem("token"),
    },
    accept:
      "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    data: {
      stationId: form.getFieldValue("stationId"),
    },
    beforeUpload(file) {
      const stationId = form.getFieldValue("stationId");
      if (!stationId) {
        message.error("请选择厂站");
        return false;
      }
      const fileTypes = [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];
      if (fileTypes.indexOf(file.type) > -1) {
        return true;
      } else {
        message.error("文件格式仅支持excel");
        return false;
      }
    },
    onChange(info) {
      setImportLoading(true);
      if (info.file.status === "done") {
        const { status, data } = info.file.response;
        setImportLoading(false);
        if (status !== "0")
          return message.error(`${info.file.name} 文件上传失败.`);
        message.success(`${info.file.name} 文件上传成功.`);
        if (data) {
          form.setFieldsValue({
            patrolStandardTemplates: data,
          });
        } else {
          form.setFieldsValue({
            patrolStandardTemplates: [],
          });
        }
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} 文件上传失败.`);
      }
    },
  };

  const getTmpContent = (e, index) => {
    InspectionApi.getTemplateItems({ id: e - 0 }).then((res) => {
      if (res.status !== "0" || res.data.length <= 0) return;
      res.data.map((item) => {
        item.periods = [
          {
            beginTime: "",
            date: "",
            day: null,
            month: null,
            period: null,
            weekDay: null,
          },
        ];
      });
      form.setFieldValue(
        ["patrolStandardTemplates", index, "patrolStandardItems"],
        res.data ? res.data : [],
      );
    });
  };

  const renderRows = ({ index, data: { fields }, style: rowStyle }) => {
    const rowRef = useRef(null);

    useEffect(() => {
      if (!rowRef.current || typeof window.ResizeObserver === "undefined")
        return;

      const observer = new window.ResizeObserver(() => {
        if (rowRef.current) {
          setRowHeight(index, rowRef.current.scrollHeight);
        }
      });

      observer.observe(rowRef.current);

      return () => {
        observer.disconnect();
      };
    }, [index, fields]);

    if (!fields) return null;
    const field = fields[index];
    // 防御性判断
    if (!field || typeof field.name !== "number") {
      console.warn("Invalid field:", field);
      return null;
    }
    return (
      <ResizeObserver
        onResize={() => {
          setRowHeight(index, rowRef.current && rowRef.current.clientHeight);
        }}
      >
        <div
          ref={rowRef}
          style={{ ...rowStyle, height: "auto", paddingRight: 8 }}
        >
          <Row key={fields.key} className="xj-standard-list" gutter={20}>
            <Col span={1} className="xj-expand-handle">
              {expandParams[index] ? (
                <MinusSquareOutlined
                  className="icon-expand"
                  onClick={() => expandDev(index)}
                />
              ) : (
                <PlusSquareOutlined
                  className="icon-expand"
                  onClick={() => expandDev(index)}
                />
              )}
            </Col>
            <Col span={9}>
              <Form.Item
                label="巡检设备"
                name={[field.name, "deviceRelevancyIds"]}
                rules={[{ required: true, message: "请选择巡检设备" }]}
                {...formLayout1}
              >
                <Cascader
                  fieldNames={fieldNames}
                  options={deviceLs}
                  placeholder="请选择巡检设备"
                  onChange={(value, options) =>
                    changeDev(value, options, index)
                  }
                />
              </Form.Item>
            </Col>
            <Col span={9}>
              <Form.Item
                label="巡检模板"
                name={[field.name, "patrolTemplateId"]}
                rules={[{ required: true, message: "请选择巡检模板" }]}
                {...formLayout1}
              >
                <Select
                  onChange={(e) => getTmpContent(e, index)}
                  placeholder="请选择巡检模板"
                >
                  {tempentItems.map((v) => {
                    return (
                      <Select.Option value={v.id} key={v.id}>
                        {v.templateName}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={5} className="xj-standard-up">
              {fields.length > 1 && (
                <Button
                  danger
                  type="primary"
                  size="mini"
                  onClick={() => removeInspectionDevice(index)}
                >
                  移除设备
                </Button>
              )}
              {index == fields.length - 1 && (
                <Button
                  type="primary"
                  size="mini"
                  onClick={() => addInspectionDevice()}
                >
                  添加设备
                </Button>
              )}
            </Col>
          </Row>
          {expandParams[index] && (
            <Form.List name={[field.name, "patrolStandardItems"]}>
              {(subfields) => (
                <>
                  {subfields.map((subfield, subIndex) => {
                    const subFieldName = subfield.name;
                    return (
                      <Row
                        key={subfield.key}
                        gutter={20}
                        className="xj-standard-item"
                      >
                        <Col span={2} className="xj-standard-no">
                          巡检项{subIndex + 1}
                        </Col>
                        <Col span={17}>
                          <Form.Item
                            noStyle
                            dependencies={[
                              [
                                "patrolStandardTemplates",
                                index,
                                "patrolStandardItems",
                              ],
                            ]}
                          >
                            {({ getFieldValue }) => {
                              const numericFlag =
                                getFieldValue([
                                  "patrolStandardTemplates",
                                  index,
                                  "patrolStandardItems",
                                  subIndex,
                                  "numericFlag",
                                ]) || undefined;
                              return (
                                <PatrolItem
                                  defectslevelLs={defectslevelLs}
                                  fields={{
                                    defectLevelId: [
                                      subFieldName,
                                      "defectLevelId",
                                    ],
                                    itemContent: [subFieldName, "itemContent"],
                                    numericFlag: [subFieldName, "numericFlag"],
                                    unit: [subFieldName, "unit"],
                                    upperLimit: [subFieldName, "upperLimit"],
                                    lowerLimit: [subFieldName, "lowerLimit"],
                                    runStatus: [subFieldName, "runStatus"],
                                    safetyPerilFlag: [
                                      subFieldName,
                                      "safetyPerilFlag",
                                    ],
                                    period: [subFieldName, "period"],
                                  }}
                                  numericFlag={numericFlag}
                                  chooseCycle={(e) =>
                                    changCycle(e, index, subIndex)
                                  }
                                  layout={{
                                    labelCol: { span: 3 },
                                    wrapperCol: { span: 21 },
                                  }}
                                />
                              );
                            }}
                          </Form.Item>
                        </Col>
                        <Col span={5} className="xj-standard-up">
                          {subfields.length > 1 && (
                            <Button
                              danger
                              type="primary"
                              size="mini"
                              onClick={() =>
                                removeInspectionItem(index, subIndex)
                              }
                            >
                              移除巡检项
                            </Button>
                          )}
                          {subIndex == subfields.length - 1 && (
                            <Button
                              type="primary"
                              size="mini"
                              onClick={() => addInspectionItem(index)}
                            >
                              添加巡检项
                            </Button>
                          )}
                        </Col>
                        {
                          <Form.Item
                            noStyle
                            dependencies={[
                              [
                                "patrolStandardTemplates",
                                index,
                                "patrolStandardItems",
                                subIndex,
                                "period",
                              ],
                              [
                                "patrolStandardTemplates",
                                index,
                                "patrolStandardItems",
                                subIndex,
                                "periods",
                              ],
                            ]}
                          >
                            {({ getFieldValue }) => {
                              const period = getFieldValue([
                                "patrolStandardTemplates",
                                index,
                                "patrolStandardItems",
                                subIndex,
                                "period",
                              ]);
                              return (
                                typeof period == "number" && (
                                  <Form.List name={[subFieldName, "periods"]}>
                                    {(Threefields) => (
                                      <>
                                        {Threefields.map(
                                          (Threefield, ThreeIndex) => {
                                            const threeFieldName =
                                              Threefield.name;
                                            return (
                                              <Col
                                                span={22}
                                                offset={2}
                                                key={Threefield.key}
                                                style={{ display: "flex" }}
                                              >
                                                <PeriodsComponent
                                                  period={[
                                                    threeFieldName,
                                                    "period",
                                                  ]}
                                                  periodVal={period}
                                                  dateFields={[
                                                    threeFieldName,
                                                    "beginTime",
                                                  ]}
                                                  weekFields={[
                                                    threeFieldName,
                                                    "weekDay",
                                                  ]}
                                                  dayFields={[
                                                    threeFieldName,
                                                    "day",
                                                  ]}
                                                  monthFields={[
                                                    threeFieldName,
                                                    "month",
                                                  ]}
                                                  layout={{
                                                    labelCol: { span: 3 },
                                                    wrapperCol: { span: 21 },
                                                  }}
                                                />
                                                <div className="period-handle-btn">
                                                  {Threefields.length > 1 && (
                                                    <MinusCircleOutlined
                                                      style={{ marginLeft: 15 }}
                                                      onClick={() =>
                                                        removePeriods(
                                                          index,
                                                          subIndex,
                                                          ThreeIndex,
                                                        )
                                                      }
                                                    />
                                                  )}
                                                  {ThreeIndex ==
                                                    Threefields.length - 1 && (
                                                    <PlusCircleOutlined
                                                      onClick={() =>
                                                        addPeriods(
                                                          index,
                                                          subIndex,
                                                          period,
                                                        )
                                                      }
                                                      style={{
                                                        marginLeft:
                                                          Threefields.length ==
                                                          1
                                                            ? 30
                                                            : 8,
                                                      }}
                                                    />
                                                  )}
                                                </div>
                                              </Col>
                                            );
                                          },
                                        )}
                                      </>
                                    )}
                                  </Form.List>
                                )
                              );
                            }}
                          </Form.Item>
                        }
                      </Row>
                    );
                  })}
                </>
              )}
            </Form.List>
          )}
        </div>
      </ResizeObserver>
    );
  };

  return (
    <>
      <AddModal
        title={title}
        footer={[
          <Row key={"btn"} span={24}>
            <Button
              key={1}
              onClick={() => handelCancel(false)}
              className="abuttons"
            >
              <i className="iconfont iconfanhui"></i>&nbsp;&nbsp;取消
            </Button>
            <Button
              key={2}
              loading={loading}
              onClick={submit}
              className="abuttons"
              type="primary"
            >
              <i className="iconfont iconbaocun"></i>&nbsp;&nbsp;保存
            </Button>
          </Row>,
        ]}
        visible={visible}
        width={1200}
        okText={"确定"}
        onCancel={handelCancel}
      >
        <div className="xj-standard-wraper">
          <Form form={form}>
            <Form.Item
              label="巡检标准"
              name="name"
              rules={[{ required: true, message: "请输入巡检标准!" }]}
              {...formLayout}
            >
              <Input placeholder={"请输入巡检标准"} />
            </Form.Item>
            <Form.Item
              label="巡检厂站"
              name="stationId"
              rules={[{ required: true, message: "请选择巡检厂站" }]}
              {...formLayout}
            >
              <Select onChange={getDevice} placeholder="请选择巡检厂站">
                {stationData.map((item) => (
                  <Select.Option value={item.value * 1} key={item.value}>
                    {item.title || item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="巡检班组"
              name="handleDeptId"
              rules={[{ required: true, message: "请选择巡检班组!" }]}
              {...formLayout}
            >
              <Select placeholder="请选择巡检班组">
                {patrolDepts.map((item) => (
                  <Select.Option value={item.id - 0} key={item.id}>
                    {item.deptName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="批量添加设备"
              name="batchDevice"
              rules={[{ required: false, message: "请选择批量添加设备" }]}
            >
              <Row>
                <Col span={18}>
                  <Button type="primary" onClick={showBatchDevModal}>
                    批量添加
                  </Button>
                </Col>
                <Col span={6}>
                  <Button
                    type="primary"
                    icon={<DownloadOutlined />}
                    style={{ marginRight: 8 }}
                    onClick={downFile}
                    loading={downLoading}
                  >
                    导出巡检
                  </Button>
                  <Upload {...uploadProps}>
                    <Button
                      type="primary"
                      loading={importLoading}
                      icon={<ImportOutlined />}
                    >
                      导入巡检
                    </Button>
                  </Upload>
                </Col>
              </Row>
            </Form.Item>
            <Form.List name="patrolStandardTemplates">
              {(fields) => {
                return (
                  <WindowScroller>
                    {({ height }) => {
                      return (
                        <AutoSizer disableHeight>
                          {() => {
                            return (
                              <VariableSizeList
                                ref={listRef}
                                width={1152}
                                height={height || 700}
                                itemCount={fields.length}
                                itemSize={getRowHeight}
                                itemData={{
                                  fields,
                                }}
                                className="standard-wraper"
                                overscanCount={1}
                              >
                                {renderRows}
                              </VariableSizeList>
                            );
                          }}
                        </AutoSizer>
                      );
                    }}
                  </WindowScroller>
                );
              }}
            </Form.List>
          </Form>
        </div>
      </AddModal>
      <Modal
        title="批量添加设备"
        open={batchDeviceVisible}
        onCancel={closeBatchDevModal}
        onOk={addBatchDev}
      >
        <Cascader
          style={{ width: "100%" }}
          multiple
          showCheckedStrategy={SHOW_CHILD}
          onChange={changeBatchDev}
          value={batchDeviceList}
          fieldNames={fieldNames}
          options={deviceLs}
          placeholder="请选择巡检设备"
        />
      </Modal>
    </>
  );
};
// 提高渲染性能
export default React.memo(AddModel);
